import { basicInitialState } from '../_utils/basicInitialState';
import { TLoginState } from './login';

export const loginInitialState: TLoginState = {
  ...basicInitialState,
  displayError: null,
};
